/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicineAliases {
  AUTOCOMPLETE_SITUATION = 'autocomplete-situation',
  BUTTON_NEW_MEDICINE = 'button-new-medicine',
  CONTEXTUAL_BAR_MEDICINES = 'contextual-bar-medicines',
  DATE_FIELD_FROM_DATE = 'date-field-from-date',
  DATE_FIELD_UNTIL_DATE = 'date-field-until-date',
  DECK_HOSPITAL = 'deck-hospital',
  DECK_PATIENT = 'deck-patient',
  FETCH_HOSPITAL = 'fetch-hospital',
  FETCH_MEDICINE_SITUATION = 'fetch-medicine-situation',
  FETCH_PATIENT = 'fetch-patient',
  FILTER_FIELD_FROM_DATE = 'filter-field-from-date',
  FILTER_FIELD_MEDICINE_SITUATION = 'filter-field-medicine-situation',
  FILTER_FIELD_UNTIL_DATE = 'filter-field-until-date',
  FILTER_MEDICINE_LIST = 'filter-medicine-list',
  HOSPITAL_CARD = 'hospital-card',
  LAYOUT_MY_CHART_MEDICINES = 'layout-my-chart-medicines',
  MAPPER_SITUATION = 'mapper-situation',
  PANEL_1 = 'panel-1',
  PANEL_MEDICINE = 'panel-medicine',
  PATIENT_CARD = 'patient-card',
  TAB_CONTROL = 'tab-control',
  TAB_HOSPITAL = 'tab-hospital',
  TAB_PATIENT = 'tab-patient',
  TEXT_SITUATION = 'text-situation',
}
export { MyChartMedicineAliases };
